
import { GetBaseUrl } from "@/utils/ConfigHelper"
import Response from "@/utils/Videomonster/Common/Response"
import axios from "axios";
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'
/**
 * @param {string} token 
 * @param {{
 *  cftoken: string
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const PostCafe24VerifyTicket = async (token, data = {}) => {
    try{    
        const url = `${GetBaseUrl()}/apis/payments/cafe24-verify-ticket`;
        const body = { accessToken: data.cftoken};
        const config={ headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.post(url, body, config);
        const result = (response.status === 200);
        const resultData = response.data.data.data;

        return new Response(result,resultData);
    }catch(e){
        throw e;
    }
}
/**
 * 
 * @param {string} token 
 * @param {{
 *  productId: string
 *  templateId: string
 *  videoId: string
 *  couponId: string
 *  provider: string | null
 * }} data 
 * @returns {Promise<Response>}
 * @throws {Error}
 */

const PostFreePayment = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/payments/free-payment`;
        const body = { ...data };
        const config = { headers: { Authorization: `Bearer ${token}` } }

        const response = await axios.post(url, body, config);
        
        const result = (response.status === 200);
        const resultData = response.data;
        return new Response(result, resultData);

    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e);
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode);
            default:
                throw e;
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  paymentId: string
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const PatchNotifyConfirm = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/payments/notify-confirm`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.patch(url, data, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  productId: string
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetFreeTickets = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/payments/free-tickets?productId=${data.productId}`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 
 * @param {string} token 
 * @param {{
 *  platform: string
 *  IAPCode: string
 *  transactionId: string
 * }} data 
 */
const PostIapSubscribePrepare = async (token, data = {}) => {
    try {
        const { platform, IAPCode, transactionId } = data
        const url = `${GetBaseUrl()}/apis/payments/iap-subscribe/prepare`
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = { platform, IAPCode, transactionId }
        const response = await axios.post(url, body, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 
 * @param {string} token 
 * @param {{
 *  id: string
 *  transactionId: string
 * }} data 
 * @returns 
 */
const PatchIapSubscribePrepareIos = async (token, data = {}) => {
    try {
        const { id, transactionId } = data
        const url = `${GetBaseUrl()}/apis/payments/iap-subscribe/prepare/ios`
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = { id, transactionId }
        const response = await axios.patch(url, body, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 
 * @param {string} token 
 * @param {{
 *  paymentId: string
 * }} data 
 */
const GetWebhookInfo = async (token, data = {}) => {
    try {
        const { paymentId } = data
        if (!paymentId) return new Response(false, PUBLIC_ERROR_CODE.CLIENT_INVALD_DATA_ERROR)

        const url = `${GetBaseUrl()}/apis/payments/${paymentId}/webhook-info`
        const config =  { headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_FORGERY:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 
 * @param {*} token 
 * @param {*} data 
 */
const PostIapValidate = async (token, data = {}) => {
    try {
        const { receipt, templateId, videoId, couponId } = data
        const url = `${GetBaseUrl()}/apis/payments/iap-validate`
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = { receipt, templateId, videoId, couponId }
        const response = await axios.post(url, body, config)
        const result = (response.status === 200)
        const resultData = response.data.data
        
        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
            case PUBLIC_ERROR_CODE.ERR_ALREADY_EXIST:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    PostCafe24VerifyTicket,
    PostFreePayment,
    PatchNotifyConfirm,
    PatchIapSubscribePrepareIos,
    GetFreeTickets,
    PostIapSubscribePrepare,
    GetWebhookInfo,
    PostIapValidate
}